document.addEventListener('alpine:init', () => {
  Alpine.data('PackBuilder', () => ({
    modal_open: false,
    main_product: null,
    pack_collection: null,
    product_4_pack: null,
    product_8_pack: null,
    product_16_pack: null,
    product_32_pack: null,
    pack_selector: {
      active: true,
      color: 'Black (70lbs)',
      size: '8',
      quantity: 1
    },
    pack_variant_for_image: null,
    pack_selector_variant: null,
    selected_variants: [],
    packs_options: [
      { value: '4-Pack', label: '4-Pack', discount: 8, qty: 2 },
      { value: '8-Pack', label: '8-Pack', discount: 27, qty: 4 },
      { value: '16-Pack', label: '16-Pack', discount: 35, qty: 8 },
      { value: '32-Pack', label: '32-Pack', discount: 35, qty: 16 }
    ],
    selected_pack: '8-Pack',
    is_pack_complete() {
      let selected_pack_option = this.packs_options.find(option => option.value == this.selected_pack);
      if (!selected_pack_option) return false;
      return this.selected_variants.length >= selected_pack_option.qty;
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      let main_product = JSON.parse(this.$el.dataset.main_product);
      let options_with_values = JSON.parse(this.$el.dataset.options_with_values);
      main_product.options_with_values = options_with_values;
      this.main_product = main_product;

      let pack_collection = JSON.parse(this.$el.dataset.pack_collection);
      this.pack_collection = pack_collection;

      this.pack_selector_variant = this.main_product.variants.find(variant => {
        return variant.option1.includes(this.pack_selector.color) && variant.option2 == '2-pack' && variant.option3.includes(this.pack_selector.size);
      });

      let product_4_pack = JSON.parse(this.$el.dataset.product_4_pack);
      if (!product_4_pack.hasOwnProperty('error')) {
        this.product_4_pack = product_4_pack;
      }
      let product_8_pack = JSON.parse(this.$el.dataset.product_8_pack);
      if (!product_8_pack.hasOwnProperty('error')) {
        this.product_8_pack = product_8_pack;
      }
      let product_16_pack = JSON.parse(this.$el.dataset.product_16_pack);
      if (!product_16_pack.hasOwnProperty('error')) {
        this.product_16_pack = product_16_pack;
      }
      let product_32_pack = JSON.parse(this.$el.dataset.product_32_pack);
      if (!product_32_pack.hasOwnProperty('error')) {
        this.product_32_pack = product_32_pack;
      }

      this.packs_options = [...this.packs_options].map(option => {
        if (option.value == '4-Pack') {
          option.product = this.product_4_pack;
        } 
        else if (option.value == '8-Pack') {
          option.product = this.product_8_pack;
        } 
        else if (option.value == '16-Pack') {
          option.product = this.product_16_pack;
        }
        else if (option.value == '32-Pack') {
          option.product = this.product_32_pack;
        }
        return option;
      });
    },
    InitWatchers() {
      this.$watch('modal_open', () => {
        if (this.modal_open) {
          document.body.classList.add('cc-modal-visible');
        }
        else {
          setTimeout(() => {
            document.body.classList.remove('cc-modal-visible');
          }, 300);
        }
      });

      this.$watch('selected_pack', () => {
        // reset quantity when pack changes
        this.pack_selector.quantity = 1;
      });

      this.$watch('pack_selector', () => {
        // console.log('Pack selector changed:', this.pack_selector);
        this.pack_variant_for_image = this.main_product.variants.find(variant => {
          return variant.option1.includes(this.pack_selector.color) && variant.option2 == '2-pack' && variant.option3.includes(this.pack_selector.size);
        });

        if (this.pack_selector.color !== '' && this.pack_selector.size !== '') {
          this.pack_selector_variant = this.main_product.variants.find(variant => {
            return variant.option1.includes(this.pack_selector.color) && variant.option2 == '2-pack' && variant.option3.includes(this.pack_selector.size);
          });
        }
      });
    },
    getQuantityLeft() {
      let selected_pack_option = this.packs_options.find(option => option.value == this.selected_pack);
      let selected_qty = this.selected_variants.length;
      // console.log('Quantity left for pack:', selected_pack_option.qty - selected_qty);
      return selected_pack_option.qty - selected_qty;
    },
    getSelectedVariantsByLength(length) {
      if (!this.selected_variants.length) return [];
      return this.selected_variants.filter(variant => variant.option3 == `${length}"`);
    },
    getSelectedColorsByLength(length) {
      let variants = this.getSelectedVariantsByLength(length);
      let colors = variants.map((variant, index) => {
        return {
          color: variant.option1,
          index: `${index}-${length}-${variant.id}`,
          variant_id: variant.id
        }
      });
      console.log('Selected colors for length:', colors);
      return colors;
    },
    u_FormatMoney(cents, format = '${{amount}}') {
      return theme.Shopify.formatMoney(cents, format);
    },
    u_IsColorAvailable(color) {
      // console.log({color, pack: this.selected_pack, size: this.pack_selector.size});
      let selected_pack = this.selected_pack;
      if (selected_pack == '32-Pack') {
        selected_pack = '16-pack';
      }

      let variant = this.main_product.variants.find(variant => {
        return variant.option1 == color && variant.option2.toLowerCase() == selected_pack.toLowerCase() && variant.option3 == `${this.pack_selector.size}"`;
      });
      // console.log(variant);
      return !variant || !variant.available;
    },
    u_IsSizeAvailable(size) {
      // console.log({size, pack: this.selected_pack, color: this.pack_selector.color});
      let selected_pack = this.selected_pack;
      if (selected_pack == '32-Pack') {
        selected_pack = '16-pack';
      }
      
      let variant = this.main_product.variants.find(variant => {
        return variant.option1 == this.pack_selector.color && variant.option2.toLowerCase() == selected_pack.toLowerCase() && variant.option3 == `${size}"`;
      });
      // console.log(variant);
      return !variant || !variant.available;
    },
    getTotalPrice() {
      let total = this.selected_variants.reduce((sum, variant) => sum + variant.price, 0);
      let savings = total * (this.packs_options.find(option => option.value == this.selected_pack)?.discount || 0) / 100;
      total = total - savings;
      // console.log('Total:', total, 'Savings:', savings);
      return {
        total: total,
        savings: savings
      };
    },
    e_AddToPack() {
      if (!this.pack_selector_variant) return;
      let qty = new Array(this.pack_selector.quantity).fill(this.pack_selector_variant);
      qty.forEach(v => {
        this.selected_variants.push(v);
      });
      // after adding, reset quantity to 1
      this.pack_selector.quantity = 1;
    },
    e_RemoveFromPack(variant_id, color_index) {
      let length = Number(color_index.split('-')[1]) + '"';
      let variant = this.selected_variants.find(v => v.id == variant_id && v.option3 == length);
      if (!variant) return;
      if (variant.quantity > 1) {
        variant.quantity -= 1;
      } 
      else {
        let index = this.selected_variants.indexOf(variant);
        this.selected_variants = [...this.selected_variants.filter((v, i) => i !== index)];
      }
    },
    e_ResetPacks() {
      this.selected_variants = [];
      this.pack_selector = {
        active: true,
        color: 'Black (70lbs)',
        size: '8',
        quantity: 1
      };
      this.pack_selector_variant = null;
    },
    async e_AddPackToCart() {
      let bundle_product = this.packs_options.find(option => option.value == this.selected_pack)?.product;

      let items = this.selected_variants.map(v => {
        return {
          id: v.id,
          quantity: 1,
          properties: {
            '_bundly__bundle_id': `gid://shopify/Product/${bundle_product.id}`,
            '_bundly__component_id': `gid://shopify/Collection/${this.pack_collection.id}`,
            '_bundly__timestamp': new Date().getTime()
          }
        }
      });

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Success:', data);
        this.e_ResetPacks();
        this.modal_open = false;

        // Open cart drawer
        document.dispatchEvent(new CustomEvent('theme:cartchanged'));
        let $cart_link = document.querySelector('.cart-link');
        if ($cart_link) {
          $cart_link.click();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }));
});